import { render, staticRenderFns } from "./EditPrestationAdditionnelle.vue?vue&type=template&id=c385f3c4&"
import script from "./EditPrestationAdditionnelle.vue?vue&type=script&lang=ts&"
export * from "./EditPrestationAdditionnelle.vue?vue&type=script&lang=ts&"
import style0 from "./EditPrestationAdditionnelle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports